import React, { useState } from "react";

import ChartLegend from "../../common/ChartLegend";
import DoughnutChart from "../../common/DoughnutChart";

import lbl from "../../../data/Labels.json";

const Chart = ({ data }) => {

  const chartData = [
    {
      label: lbl.Present,
      value: data?.present_count || 0,
      color: "#48C29D",
    },
    {
      label: lbl.Absent,
      value: data?.absent_count || 0,
      color: "#9A3859",
    },
    {
      label: lbl.Holiday,
      value: data?.holiday_count || 0,
      color: "#EF9C0E",
    },
  ];

  return data ? (
    <div style={{margin: "10px", justifyContent: "center" , justifyItems: "center" }}>
      <div>
        <div className="print-doughnut-chart-panel" style={{
          display:"grid", 
          gridTemplateColumns:"70% 30%",
          backgroundColor: "#f8f8f8",
          borderRadius: "10px",
          padding: "15px"
        }}>
          <div className="chart-legend">
            <ChartLegend data={chartData} symbol={"d"} />
          </div>
          <div className="chart">
            <DoughnutChart data={chartData} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Chart;
